export const roommatesRoutes = {
  roommatesRelatedToSpecificResidency: residencyId => "/residencies/".concat(residencyId, "/roommates")
};